import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import { setUserProductCategories } from '../../redux/Actions/productCategoriesAction';
import { fetchAddToCart } from '../../redux/Actions/addCartAction';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const base_url = process.env.REACT_APP_BACKEND_URL;


const priceListData={data:{"Response": {
    "response_code": "",
    "response_message": ""
},"data": {
    "shop": {
        "id": "1",
        "owner": "",
        "name": "Xcel Dry Cleaners",
        "email": "xceldrycleaners@shop.com",
        "order_closing_time": ""
    },
    "minimum_order_amount": "20.00",
    "vat_percentage": "20.00",
    "daily_working_hours": "9",
    "price_currency": "£",
"category": [{
        "main_category_id": "1",
        "main_category_name": "Men",
        "selection": "f2faff",
        "background": "0d8ada",
        "andriod_banner_img": "",
        "ios_banner_img": "",
        "is_expandable": "0",
        "sub_categories": [{
            "sub_category_id": "1",
            "sub_category_name": "Silk Shirt",
            "process_time": "48",
            "quantity": "0",
            "andriod_sub_category_img": "",
            "ios_sub_category_img": "",
            "total_price": "5.00",
            "options": [{
                "option_id": "1",
                "option_name": "Washed, ironed and hung",
                "option_description": "Washed, ironed and hung",
                "option_price": "5.00",
                "is_default": "1"
            }, {
                "option_id": "2",
                "option_name": "Washed, ironed and folded",
                "option_description": "Washed, ironed and folded",
                "option_price": "5.00",
                "is_default": "0"
            }]
}]}]

}},
rowcount:0,
active:"active"
}




function SectionThreeThemeFive() {

    const [priceList, setPriceList] = useState< any | null>(priceListData)
    const [active, setActive] = useState(null)
    const [quantities, setQuantities] = useState<{[key: string]: number}>({})

    const dispatch = useDispatch<any>();
    const navigate = useNavigate();

    const settings: any = useSelector<any>(
        (state) => state.settings
      );

	useEffect(() => {

        const headers = {
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": "*"
        }

        axios.get(`${base_url}/api/get_categories?group_id=1`,{
        headers: headers

            }).then(e=>{setPriceList({data:e.data})
            e.data.data.category.slice(0,1).map((category:any) =>

            setActive(category.main_category_name)
    )
})



    }, [])

    const getQuantity = (subCategoryId: string, mainCategoryId: string) =>
        quantities[`${mainCategoryId}_${subCategoryId}`] || 0;

    const onAddToCartHandler = (subCategoryId: string, mainCategoryId: string, type: 'add' | 'minus') => {
        const key = `${mainCategoryId}_${subCategoryId}`;
        const current = quantities[key] || 0;
        if (type === 'minus' && current <= 0) return;
        setQuantities(prev => ({
            ...prev,
            [key]: type === 'add' ? current + 1 : current - 1
        }));
    };

    let totalItems = 0;
    let totalPrice = 0;
    priceList.data.data.category.forEach((cat: any) => {
        cat.sub_categories.forEach((sub: any) => {
            const qty = getQuantity(sub.sub_category_id, cat.main_category_id);
            totalItems += qty;
            totalPrice += qty * parseFloat(sub.total_price);
        });
    });

    const handleGoToCart = () => {
        const postalCode = (() => {
            try { return JSON.parse(localStorage.getItem('postalCode') || 'null'); }
            catch { return null; }
        })();

        if (!postalCode) {
            toast.warning('Please enter your postal code to proceed');
            const bookSection = document.getElementById('booknow') || document.getElementById('book-now') || document.getElementById('section-one');
            if (bookSection) bookSection.scrollIntoView({ behavior: 'smooth' });
            return;
        }

        const shopId = localStorage.getItem('shop_id');
        let finalTotalPrice = 0;
        let payload: any = {
            shop_id: shopId,
            postal_code: postalCode,
            group_id: "1",
            order_type: "0",
            total_tax_price: "0",
            total_price_without_deductions: totalPrice.toString(),
            total_price_without_vat: totalPrice.toString(),
            cart_total_count: totalItems,
        };

        const updatedCategories = priceList.data.data.category.map((cat: any) => ({
            ...cat,
            sub_categories: cat.sub_categories.map((sub: any) => ({
                ...sub,
                quantity: getQuantity(sub.sub_category_id, cat.main_category_id).toString()
            }))
        }));
        dispatch(setUserProductCategories(updatedCategories));

        priceList.data.data.category.forEach((item: any) => {
            item.sub_categories.forEach((sub: any) => {
                const qty = getQuantity(sub.sub_category_id, item.main_category_id);
                if (qty > 0) {
                    const selectedOption = sub.options?.[0];
                    finalTotalPrice += qty * parseFloat(sub.total_price);
                    payload = {
                        ...payload,
                        [`option_${item.main_category_id}_${sub.sub_category_id}_${selectedOption?.option_id}`]: selectedOption?.option_id,
                        [`quantity_${item.main_category_id}_${sub.sub_category_id}_${selectedOption?.option_id}`]: qty.toString(),
                        [`price_${item.main_category_id}_${sub.sub_category_id}_${selectedOption?.option_id}`]: selectedOption?.option_price,
                        [`product_${item.main_category_id}_${sub.sub_category_id}_${selectedOption?.option_id}`]: sub.sub_category_name,
                        [`process_time_${item.main_category_id}_${sub.sub_category_id}_${selectedOption?.option_id}`]: sub.process_time || "48",
                        [`productcount_${item.main_category_id}_${sub.sub_category_id}_${selectedOption?.option_id}`]: qty.toString(),
                    };
                }
            });
        });

        payload = { ...payload, total_price: finalTotalPrice.toString() };
        localStorage.setItem('order_type', '0');
        localStorage.setItem('shop_id', shopId || '');
        dispatch(fetchAddToCart(payload));

        const userinfo = JSON.parse(localStorage.getItem('userDetails') || 'null');
        if (userinfo) {
            navigate('/checkout');
        } else {
            navigate('/guestLogin');
        }
    };

    const pricerow=(subcategory: any, mainCategoryId: string)=>
    {
        const qty = getQuantity(subcategory.sub_category_id, mainCategoryId);

      return <div className="col-md-12" key={subcategory.sub_category_id}>
        <div className="price-list-row-wrap">
            <div className="price-list-row-info">
                <span className="homeproduct">{subcategory.sub_category_name}</span>
                <span className="homeprice" data-bs-toggle="tooltip" data-html="true" title={
                    subcategory.options
                    .filter((options: any) => options.is_default == '1')
                    .map((item: any) => item.option_description + ' : ' + item.option_price)
                }>
                    {settings?.WebmasterSettings?.currency}{subcategory.total_price}
                </span>
            </div>
            <div className="price-list-row-cart">
                {qty === 0 ? (
                    <button
                        className="btn-pricing-add"
                        onClick={() => onAddToCartHandler(subcategory.sub_category_id, mainCategoryId, 'add')}
                    >
                        + Add
                    </button>
                ) : (
                    <div className="pricing-qty-control">
                        <button
                            className="pricing-qty-btn"
                            onClick={() => onAddToCartHandler(subcategory.sub_category_id, mainCategoryId, 'minus')}
                        >
                            −
                        </button>
                        <span className="pricing-qty-value">{qty}</span>
                        <button
                            className="pricing-qty-btn"
                            onClick={() => onAddToCartHandler(subcategory.sub_category_id, mainCategoryId, 'add')}
                        >
                            +
                        </button>
                    </div>
                )}
            </div>
        </div>
     </div>
    }



    const popprice=(category: any)=>
{
        return category.sub_categories.map((subcategory:any)=>
   pricerow(subcategory, category.main_category_id)
    )
 }


    const handleClick = (_event:any,category:any,_catindex:any) =>{

        setActive(category.main_category_name)


      }




    return (
        <>
        <style>{`
            .price-list-row-wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 16px;
                background: #fff;
                border-radius: 8px;
                margin-bottom: 8px;
                box-shadow: 0 1px 4px rgba(0,0,0,0.06);
            }
            .price-list-row-info {
                display: flex;
                align-items: center;
                gap: 16px;
                flex: 1;
            }
            .price-list-row-cart {
                flex-shrink: 0;
                margin-left: 12px;
            }
            .btn-pricing-add {
                background: #5c0385;
                color: #fff;
                border: none;
                border-radius: 20px;
                padding: 5px 16px;
                font-size: 13px;
                font-weight: 600;
                cursor: pointer;
                transition: background 0.2s;
            }
            .btn-pricing-add:hover {
                background: #3d0260;
            }
            .pricing-qty-control {
                display: flex;
                align-items: center;
                gap: 6px;
                background: #f4f0f8;
                border-radius: 20px;
                padding: 3px 8px;
            }
            .pricing-qty-btn {
                background: #5c0385;
                color: #fff;
                border: none;
                border-radius: 50%;
                width: 26px;
                height: 26px;
                font-size: 16px;
                line-height: 1;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
            }
            .pricing-qty-btn:hover {
                background: #3d0260;
            }
            .pricing-qty-value {
                min-width: 20px;
                text-align: center;
                font-weight: 700;
                font-size: 14px;
                color: #5c0385;
            }
            .pricing-cart-footer {
                position: sticky;
                bottom: 0;
                background: #5c0385;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 14px 24px;
                border-radius: 12px;
                margin-top: 20px;
                box-shadow: 0 -2px 12px rgba(92,3,133,0.18);
                z-index: 10;
            }
            .pricing-cart-footer-info {
                display: flex;
                flex-direction: column;
                gap: 2px;
            }
            .pricing-cart-footer-items {
                font-size: 13px;
                opacity: 0.85;
            }
            .pricing-cart-footer-total {
                font-size: 18px;
                font-weight: 700;
            }
            .btn-go-to-cart {
                background: #fff;
                color: #5c0385;
                border: none;
                border-radius: 24px;
                padding: 10px 24px;
                font-size: 15px;
                font-weight: 700;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 8px;
                transition: background 0.2s, color 0.2s;
            }
            .btn-go-to-cart:hover {
                background: #f4e6ff;
            }
        `}</style>
        <div className="price-section pricing-v2 aos-init" id="pricing" data-aos="zoom-in-up">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section-title text-center aos-init" data-aos="fade-down">
                        <h2>Pricing &amp; List</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-10 center-block no-float">
                    <div className="tab-content mt-10">
                        <div id="laundry-price-section">
                            <div className="price-list-items text-center">
                                {
                              <ul className="list-inline">
                                    {
                                        priceList.data.data.category.map((category:any,catindex:any) => <li  id={'licategory'+catindex} className={ (active==category.main_category_name)?`list-inline-item active`:`list-inline-item`} onClick ={(event) => handleClick(event, category,catindex)}>
                                            <a data-bs-toggle="tab" href="#" className="btn btn-lg btn-default " onClick={ (event) => event.preventDefault() } >
                                                {category.main_category_name}
                                            </a>
                                        </li>)
                                    }
                                </ul>

}
                            </div>
                            <div className="row price-list-contents">
                                <div className="col-md-12 mx-auto">
                                 <div className="tab-content">{
                                        priceList.data.data.category.map((category:any) =>
                                        <div id="price-main-categ-2-3" className={(active==category.main_category_name) ?"tab-pane in price-list-details price-list-details-style mt-4 active":"tab-pane fade in price-list-details price-list-details-style mt-4 "}>
                                                          {popprice(category)}
                            </div>


                                    )  }

                                    {totalItems > 0 && (
                                        <div className="pricing-cart-footer">
                                            <div className="pricing-cart-footer-info">
                                                <span className="pricing-cart-footer-items">
                                                    {totalItems} item{totalItems > 1 ? 's' : ''} added
                                                </span>
                                                <span className="pricing-cart-footer-total">
                                                    {settings?.WebmasterSettings?.currency}{totalPrice.toFixed(2)}
                                                </span>
                                            </div>
                                            <button className="btn-go-to-cart" onClick={handleGoToCart}>
                                                Go to Cart <i className="fas fa-arrow-right"></i>
                                            </button>
                                        </div>
                                    )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




</div>
<ToastContainer />
</>
)




}

export default SectionThreeThemeFive
